import React, { useEffect, useState } from "react";
import CustomerFilteringSection from "./CustomerFilteringSection";
import CustomerList from "./CustomerList";
import CommonPaginationSection from "../../components/common/CommonPaginationSection";
import useCustomers from "../../hooks/useCustomers";
import { templateCustomerData } from "../../data/order/customerTableData";
import { customerConfig } from "../../customerConfig";
import CustomerSortHeader from "./CustomerSortHeader";

function CustomersTable() {
  const { getCustomers } = useCustomers();
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([]);
  const [ogData, setOgData] = useState([]);
  const [search, setSearch] = useState("");
  const [reload, setReload] = useState(1);
  const [tab, setTab] = useState(customerConfig.filterTabs.all.code);

  // console.log({ loading });

  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10,
    total: 10,
  });
  const [sort, setSort] = useState({ orderBy: "firstName", order: "asc" });

  const loadData = async () => {
    const [total, tableData, data] = await getCustomers({
      setLoading,
      limit: pagination.perPage,
      page: pagination.page,
      search,
      tab,
      orderBy: sort.orderBy,
      order: sort.order,
    });
    setPagination({ ...pagination, total });
    setOrders(tableData);
    setOgData(data);
  };

  useEffect(() => {
    loadData();
  }, [search, pagination.page, pagination.perPage, reload, tab, sort]);

  return (
    <div className="w-full flex flex-col pb-32">
      <span className="text-xl font-semibold">Agents</span>
      <CustomerFilteringSection
        search={search}
        setTab={setTab}
        setSearch={(text) => {
          setPagination({ ...pagination, page: 1 });
          setSearch(text);
        }}
      />
      <CustomerSortHeader
        sortField={sort.orderBy}
        sortType={sort.order}
        onSortChange={setSort}
      />
      {loading ? (
        <div className="w-full flex flex-col py-4 items-center justify-center">
          <div className="primaryLoader"></div>
        </div>
      ) : (
        <>
          <CustomerList
            loading={loading}
            ogData={ogData}
            orders={orders}
            callback={(updatedUser) => {
              const updatedUsersData = ogData.map((data) =>
                data._id === updatedUser?._id
                  ? updatedUser?.detail?._id
                    ? updatedUser
                    : { ...updatedUser, detail: data?.detail }
                  : data,
              );
              const [updatedOrders, updatedData] = [
                updatedUsersData.map((item) => templateCustomerData(item)),
                updatedUsersData,
              ];
              setOrders(updatedOrders);
              setOgData(updatedData);
            }}
          />
          <CommonPaginationSection
            perPage={pagination.perPage}
            page={pagination.page}
            total={pagination.total}
            callback={(page, perPage) =>
              setPagination({ ...pagination, page, perPage })
            }
          />
        </>
      )}
    </div>
  );
}

export default CustomersTable;
